// extracted by mini-css-extract-plugin
module.exports = {"iframe":"AppViewer_iframe__2fpb6"};